module.exports = __webpack_public_path__ + "static/wheelmen-341e901c2e70da177864bf26f50a0e69.jpg";